import gsap from "gsap";

export class Guides {
  constructor() {
    this.grid = document.querySelector(".guides");
    this.toggleGrid = null;
    this.init();
  }

  init() {
    if (!this.grid) return;

    // Set up a tween that animates the grid in and out
    this.toggleGrid = gsap
      .to(this.grid, {
        duration: 0.5,
        ease: "power2.inOut",
        scaleY: 1,
        paused: true,
      })
      .reverse();

    // Check if the grid was enabled before using in-memory storage
    this.checkStoredState();
    this.setupKeyboardListener();
  }

  checkStoredState() {
    // Check if the grid was enabled before
    if (localStorage.getItem("debug") === "true") {
      this.toggleGrid.play().progress(1);
    }
  }

  setupKeyboardListener() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "g" && e.ctrlKey) {
        this.toggle();
      }
    });
  }

  toggle() {
    if (!this.toggleGrid) return;

    // Toggle the grid when ⌃G is pressed
    this.toggleGrid.reversed()
      ? this.toggleGrid.play()
      : this.toggleGrid.reverse();

    // Save the state in local storage
    localStorage.setItem("debug", !this.toggleGrid.reversed());
  }

  show() {
    if (this.toggleGrid && this.toggleGrid.reversed()) {
      this.toggleGrid.play();
    }
  }

  hide() {
    if (this.toggleGrid && !this.toggleGrid.reversed()) {
      this.toggleGrid.reverse();
    }
  }
}
